/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useOnRouteChange = (callback: () => void) => {
  const history = useHistory();

  useEffect(() => {
    const handleLocationChange = (
      location: { pathname: string },
      action: any
    ) => {
      callback();
    };

    const unlisten = history.listen(handleLocationChange);

    return () => {
      unlisten();
    };
  }, [history]);
};

export default useOnRouteChange;
